import { render, staticRenderFns } from "./thing_create.vue?vue&type=template&id=b9fd5f2c&"
import script from "./thing_create.vue?vue&type=script&lang=js&"
export * from "./thing_create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports